import type { HTMLAttributes, ReactNode } from 'react';
import { Info, CheckCircle2, AlertCircle } from 'lucide-react';
import { cn } from '../utils/cn.js';

export interface NoticeProps extends HTMLAttributes<HTMLDivElement> {
  tone?: 'info' | 'success' | 'warning';
  icon?: ReactNode;
}

const ICONS = {
  info: <Info size={16} aria-hidden />,
  success: <CheckCircle2 size={16} aria-hidden />,
  warning: <AlertCircle size={16} aria-hidden />,
};

export function Notice({
  tone = 'info',
  icon,
  className,
  children,
  ...rest
}: NoticeProps) {
  return (
    <div className={cn('notice', `notice-${tone}`, className)} {...rest}>
      <span className="notice-icon">{icon ?? ICONS[tone]}</span>
      <span className="notice-body">{children}</span>
    </div>
  );
}
